<button
  type="button"
  (click)="toggle()"
  class="h-8 w-8 rounded-[10px] border border-[#A9B1F6] bg-[#EEF0FF] flex items-center justify-center text-[#616AAB] shadow-sm transition-colors hover:bg-[#E4E8FF] hover:text-[#4E568D] hover:border-[#8D97E8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A9B1F6]"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-label]="'listSettingsPopover.aria' | t"
>
  <lucide-icon name="settings" class="h-4 w-4"></lucide-icon>
</button>

@if (isOpen()) {
  <div
    #panel
    class="absolute right-0 top-full mt-1.5 w-72 rounded-xl border border-[var(--border)] bg-[var(--bg-surface)] shadow-xl py-2 z-30"
  >
    <div class="px-3 py-1.5">
      <h3 class="text-xs font-semibold uppercase tracking-wider text-[var(--muted)]">
        {{ 'listSettingsPopover.title' | t }}
      </h3>
    </div>

    <div class="px-3 py-2 border-t border-[var(--border)]">
      <p class="text-xs font-medium text-[var(--muted)] mb-2">{{ 'listSettingsPopover.sections.view' | t }}</p>
      <div class="flex items-center justify-between gap-2">
        <span class="text-sm text-[var(--text)]">{{ 'listSettingsPopover.grouping' | t }}</span>
        <span class="text-xs text-[var(--faint)]">{{ 'listSettingsPopover.workflowStage' | t }}</span>
      </div>
      <label class="flex items-center justify-between gap-2 mt-2 cursor-pointer">
        <span class="text-sm text-[var(--text)]">{{ 'listSettingsPopover.showCompleted' | t }}</span>
        <input
          type="checkbox"
          [checked]="showClosedItems()"
          (change)="onShowClosedChange($any($event.target).checked)"
          class="h-4 w-4 rounded border-[var(--border)] text-[var(--focus)] focus:ring-[var(--focus)]"
        />
      </label>
    </div>

    <div class="px-3 py-2 border-t border-[var(--border)]">
      <p class="text-xs font-medium text-[var(--muted)] mb-2">{{ 'listSettingsPopover.sections.workflowStages' | t }}</p>
      <button
        type="button"
        (click)="onManageStatus()"
        class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
      >
        <lucide-icon name="sliders-horizontal" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        {{ 'listSettingsPopover.manageStages' | t }}
      </button>
    </div>

    <div class="px-3 py-2 border-t border-[var(--border)]">
      <p class="text-xs font-medium text-[var(--muted)] mb-2">{{ 'listSettingsPopover.sections.fields' | t }}</p>
      <button
        type="button"
        (click)="onCustomFields()"
        class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
      >
        <lucide-icon name="columns-3" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        {{ 'listSettingsPopover.customFields' | t }}
      </button>
      <button
        type="button"
        (click)="onDisplayFields()"
        class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
      >
        <lucide-icon name="eye" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        {{ 'listSettingsPopover.displayFields' | t }}
      </button>
      @if (canManageCardFieldDisplayOrder()) {
        <button
          type="button"
          (click)="onCardFieldDisplayOrder()"
          class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
        >
          <lucide-icon name="arrow-down-wide-narrow" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
          {{ 'listSettingsPopover.cardFieldDisplayOrder' | t }}
        </button>
      }
    </div>

    @if (canManageWhatsAppService()) {
      <div class="px-3 py-2 border-t border-[var(--border)]">
        <button
          type="button"
          (click)="onWhatsAppService()"
          class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
        >
          <lucide-icon name="message-circle" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
          {{ 'whatsappservice.title' | t }}
        </button>
      </div>
    }

    <div class="px-3 py-2 border-t border-[var(--border)]">
      <p class="text-xs font-medium text-[var(--muted)] mb-2">{{ 'listSettingsPopover.sections.permissions' | t }}</p>
      <button
        type="button"
        (click)="onProcessMembers()"
        class="w-full flex items-center gap-2 px-2 py-1.5 rounded-[var(--r-sm)] text-sm text-[var(--text)] hover:bg-[var(--hover)] text-left"
      >
        <lucide-icon name="users" class="h-4 w-4 text-[var(--muted)]"></lucide-icon>
        {{ 'listSettingsPopover.processMembers' | t }}
      </button>
      @if (!isAdmin()) {
        <p class="text-xs text-[var(--faint)] mt-1.5 px-0.5">{{ 'listSettingsPopover.adminOnly' | t }}</p>
      }
    </div>
  </div>
}

